import { render, staticRenderFns } from "./WarehousesList.vue?vue&type=template&id=4fcc3e26&"
import script from "./WarehousesList.vue?vue&type=script&lang=ts&"
export * from "./WarehousesList.vue?vue&type=script&lang=ts&"
import style0 from "./WarehousesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports